<div class="card-item-snake-top-arrow"></div>
<div class="card-item-snake-top-info-box">
  @if (card().completed || card().started) {
    <div class="started-box"></div>
  } @else {
    <div class="not-started-box"></div>
  }
</div>

<ptl-card-item-main-view [card]="card()" [cardIndex]="cardIndex()" (cardClick)="cardClick.emit($event)"></ptl-card-item-main-view>
